module.exports = __webpack_public_path__ + "static/media/spy.b6cba4db.jpg";